import { AfterViewInit, Component, ElementRef, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBar } from "@angular/material/snack-bar";

export type LoadingProgress = {
	done: boolean;
	percent?: number;
};

export interface NotificationConfig  {
	message: string;
	snackBar: MatSnackBar;
	loadingCallback: (callback: (progress: LoadingProgress) => void) => void;
	status?: "Success" | "Warning" | "Error";
	type?: "Text" | "Detail" | "Loading" | "Progress";
	title?: string;
};

@Component({
	selector: "kt-new-action-notification",
	templateUrl: "./new-action-notification.component.html",
	styleUrls: ["./new-action-notification.component.scss"],
})
export class NewActionNotificationComponent implements AfterViewInit {
	collapsed = false;

	constructor(
		private elementRef: ElementRef,
		@Inject(MAT_SNACK_BAR_DATA)
		public data: NotificationConfig
	) {}

	ngAfterViewInit() {
		const pane = (this.elementRef.nativeElement as HTMLElement).closest(
			".cdk-overlay-pane"
		);
		if (pane) {
			pane.classList.add("new-action-notification-overlay");
		}

		if (this.config.type === "Loading") {
			this.config.loadingCallback((progress) => {
				if (progress.done) {
					return this.config.snackBar.dismiss();
				}
			});
		}
	}

	closeNotification() {
		if (this.config.type === "Loading") {
			this.collapsed = true;
		} else {
			this.config.snackBar.dismiss();
		}
	}

	expandNotification() {
		if (this.config.type === "Loading" && this.collapsed) {
			this.collapsed = false;
		}
	}

	get config() {
		return {
			status: "Success",
			type: "Text",
			...this.data,
		};
	}
}
